export { default } from "./AuthenticateClient.js";
